import React from 'react';

import FieldHintText from './FieldHintText';
import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FormGroup from './FormGroup';
import UploadAvatarInput from './UploadAvatarInput';

type Props = {
    name: string;
    label?: string;
    hint?: string;
    value: string;
    onChange: (ev: any) => void;
    error?: string;
};

const FormUploadAvatarInput: React.FC<Props> = (props) => (
    <FormGroup itemsSpacing={5} style={{ minWidth: 114 }}>
        <FieldLabel>{props.label}</FieldLabel>
        <UploadAvatarInput style={{ fontSize: '1.6rem' }} {...props} />
        {props.hint && <FieldHintText>{props.hint}</FieldHintText>}
        <FieldStatusText status="error">{props.error}</FieldStatusText>
    </FormGroup>
);

export default FormUploadAvatarInput;
